'use strict';

const dealCarouselTemplate = require('../main.html.mustache');

function showDealCarousel() {
  const $mainContent = $('.mpp-container .main-content');
  const $rightRail = $('.mpp-container .main-content-right-column');

  if (!$mainContent.length || !$rightRail.length) {
    return false;
  } // Do not add the deal carousel if the righthand rail is already larger than the main content.

  if ($rightRail.height() >= $mainContent.height()) {
    return false;
  } else {
    return true;
  }
}

class DealCarousel {
  constructor(el, deals) {
    this.el = el;
    this.deals = deals;
    this.$el = $(this.el);
    this.render();
    this.$jcarousel = this.$el.find('.jcarousel');
    this.initJCarousel();
    this.initBindings();
    this.scrollAutomatically();
  }

  render() {
    const templateData = {
      deals: this.deals,
    };

    templateData.translate = templateData.t = () => text =>
      I18n.translate(text);

    const html = dealCarouselTemplate.render(templateData);
    this.$el.html(html);
    return this.$el.slideDown(function() {
      return GIG.Utils.truncateElements(this.$el);
    });
  }

  onResize() {
    if (!this.$el.is(':visible')) {
      return null;
    }

    if (this.resizeTimer != null) {
      clearTimeout(this.resizeTimer);
    }

    this.resizeTimer = setTimeout(() => {
      this.destroyJCarousel();
      return this.initJCarousel();
    }, 250);
    return this.resizeTimer;
  }

  initBindings() {
    this.$el.find('.arrows .next').click(() => this.moveNext());
    this.$el.find('.arrows .back').click(() => this.moveBack());
    return $(window).on('resize', () => this.onResize());
  }

  initJCarousel() {
    const width = this.$jcarousel.outerWidth();
    this.$jcarousel.find('li').css('width', `${width}px`);
    this.$jcarousel.jcarousel({
      wrap: 'circular',
    });
    this.jcarousel = this.$jcarousel.data('jcarousel');
    const $jcarouselUl = this.$jcarousel.find('ul');
    $jcarouselUl.css('left', 0);
    return $jcarouselUl.scrollTo(0, {
      axis: 'x',
    });
  }

  destroyJCarousel() {
    return this.jcarousel.destroy();
  }

  moveNext() {
    this.jcarousel.scroll('+=1');
    return this.scrollAutomatically();
  }

  moveBack() {
    this.jcarousel.scroll('-=1');
    return this.scrollAutomatically();
  }

  scrollAutomatically() {
    if (this.scrollTimeout != null) {
      clearInterval(this.scrollTimeout);
    }

    this.scrollTimeout = setInterval(() => {
      this.moveNext();
      return this.scrollAutomatically();
    }, 10000);
    return this.scrollTimeout;
  }
}

exports.DealCarousel = DealCarousel;
$(() => {
  // do nothing if right rail is not present (mobile)
  if (!($('.mpp-container .main-content-right-column').length > 0)) {
    return null;
  } // do not show the carousel if the MPP has deals

  if ($('.mpp-container #multiple-offers .mpp-deal-card').length > 0) {
    return null;
  } // do not show the carousel if the righthand rail is already larger than the main content

  if (!showDealCarousel()) {
    return null;
  }

  return $('.mpp-container').on('nearby-deals-loaded', (event, nearbyDeals) => {
    new DealCarousel(
      '.mpp-container .main-content-right-column .deal-carousel',
      nearbyDeals.markers
    );

    if (
      $('.mpp-container .main-content-right-column .deal-carousel.sem').length >
      0
    ) {
      return $('.mpp-container .main-content-right-column .photo-tiles').css(
        'margin-top',
        '20px'
      );
    }
    return null;
  });
});
